import { toast } from 'react-toast';


export const ToastEmitter = (message, type = 'success')=>{
        return toast[type](message, {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
                });

}
